import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import UserManagement from '../settings/UserManagement';

const UserManagementPage = () => {
  const { user } = useAuth();
  const isAdmin = user?.roles?.includes('ROLE_ADMIN');

  if (!isAdmin) {
    return (
      <div className="flex items-center justify-center py-16">
        <div className="card bg-base-100 border border-red-200 shadow-sm max-w-md w-full">
          <div className="card-body items-center text-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-12 h-12 text-red-400 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>
            <h3 className="font-semibold text-slate-800">Access Denied</h3>
            <p className="text-sm text-slate-500 mt-1">Admin privileges required to access user management.</p>
          </div>
        </div>
      </div>
    );
  }

  return <UserManagement />;
};

export default UserManagementPage;
